import PrebuiltBetAvantgardeImpl from './prebuilt-bet-avantgarde.js';
import MojitoCore from 'mojito/core';
import PropTypes from 'prop-types';

const UIView = MojitoCore.Presentation.UIView;

/**
 * PrebuiltBetAvantgarde view that renders prebuilt bet card with the avantgarde layout.
 * The avantgarde layout always renders on a light card surface without a background image.
 *
 * @class PrebuiltBetAvantgarde
 * @memberof Mojito.Modules
 */

/**
 * PrebuiltBetAvantgarde prop types.
 *
 * @property {node} [children] - Child components.
 * @property {object} event - Event data.
 * @property {object} market - Market data.
 * @property {object} [boostedMarket] - Boosted market data.
 * @property {Function} [onEventClick] - Callback to get state of child element loading.
 * @property {boolean} [showMarketName = true] - If true, then market name per part will be shown.
 * @property {boolean} [shouldRequestData = true] - Flag indicating whether the part events and markets should be requested from content. If false, then part metadata is resolved from the data already available in a store.
 * @property {string} [class] - Class name.
 *
 * @memberof Mojito.Modules.PrebuiltBetAvantgarde
 */
const propTypes = {
    children: PropTypes.node,
    event: PropTypes.object.isRequired,
    market: PropTypes.object.isRequired,
    boostedMarket: PropTypes.object,
    onEventClick: PropTypes.func,
    showMarketName: PropTypes.bool,
    shouldRequestData: PropTypes.bool,
    class: PropTypes.string,
};

const defaultProps = {
    showMarketName: true,
    shouldRequestData: true,
    class: '',
};

export default UIView('PrebuiltBetAvantgarde', PrebuiltBetAvantgardeImpl, propTypes, defaultProps);
